import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class CollapsibleBlock extends Vue {
    _data: any;

    @Prop() title: string;
    @Prop() isOpen: boolean;

    data() {
        return {
            show: this.isOpen
        };
    }

    invert() {
        this._data.show = !this._data.show;
    }
}


// WEBPACK FOOTER //
// ./www/js/Components/CollapsibleBlock/CollapsibleBlock.ts